<template>
  <div>
    <div class="flex-row j_b">
      <p class="news_title">消息详情</p>
      <router-link to="/messageList" slot="extra">返回列表</router-link>
    </div>
    <div class="detail_box">
      <div class="flex mb20">
        <p class="label">消息标题</p>
        <p>{{ detail.title }}</p>
      </div>
      <div class="flex mb20">
        <p class="label">消息类型</p>
        <p>{{ detail.type == 0 ? "文本消息" : "图文消息" }}</p>
      </div>
      <div class="flex mb20">
        <p class="label">发送时间</p>
        <p>{{ detail.effectTime }}</p>
      </div>
      <div class="flex mb20">
        <p class="label">推送首页</p>
        <p>{{ detail.indexFlag == 0 ? "否" : "是" }}</p>
      </div>
      <div class="flex mb20">
        <p class="label">消息内容</p>
        <div v-html="detail.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      detail: {},
    };
  },
  created() {
    let id = this.$route.query.id;
    this.$api.msgDetail({ id: id }).then((res) => {
      if (res.code == "200") {
        this.detail = res.data || [];
      } else {
        this.detail = [];
      }
    });
  },
  methods: {},
};
</script>

<style scoped>
.news_title {
  height: 20px;
  line-height: 20px;
  font-size: 16px;
  color: #17233d;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.flex-row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.j_b {
  justify-content: space-between;
}
.detail_box {
  margin: 40px;
  color: #333;
  font-size: 15px;
}
.flex {
  display: flex;
}
.label {
  width: 100px;
  flex-shrink: 0;
  white-space: nowrap;
}
.mb20 {
  margin-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/message/messageDetail.vue